export default __webpack_public_path__ + "static/media/miguel-lopes-27.7a182cb9.jpg";